import { render, staticRenderFns } from "./recommendCourse.vue?vue&type=template&id=d007e2f4&scoped=true&"
import script from "./recommendCourse.vue?vue&type=script&lang=js&"
export * from "./recommendCourse.vue?vue&type=script&lang=js&"
import style0 from "./recommendCourse.vue?vue&type=style&index=0&id=d007e2f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d007e2f4",
  null
  
)

export default component.exports